import type { ThemeOptions } from '@mui/material/styles';
import { commonComponentsStyles } from './commonComponents.style';

type Components = NonNullable<ThemeOptions['components']>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function mergeRootStyleOverrides(commonRoot: any, dsRoot: any, props: any) {
  const baseStyles =
    typeof commonRoot === 'function'
      ? commonRoot(props)
      : typeof commonRoot === 'object' && commonRoot !== null
      ? commonRoot
      : {};
  const dsStyles =
    typeof dsRoot === 'function' ? dsRoot(props) : typeof dsRoot === 'object' && dsRoot !== null ? dsRoot : {};
  return { ...baseStyles, ...dsStyles };
}

/**
 * When merging design-system `components` onto the dashboard base theme, MUI `deepmerge` **replaces**
 * `styleOverrides.root` if the DS merge yields a callback and the base used an object (or vice versa).
 * That drops `commonComponentsStyles` rules — e.g. InputBase pill styles or Button `sizeSmall` height.
 *
 * This wrapper restores the base `root` output and layers DS `root` on top.
 */
export function mergeUiComponentsPreservingCommonInputBase(dsComponents: Components): Components {
  const common = commonComponentsStyles;
  const commonInputRoot = common.MuiInputBase?.styleOverrides?.root;
  const dsInputRoot = dsComponents.MuiInputBase?.styleOverrides?.root;
  const commonButtonRoot = common.MuiButton?.styleOverrides?.root;
  const dsButtonRoot = dsComponents.MuiButton?.styleOverrides?.root;

  return {
    ...dsComponents,
    MuiInputBase: {
      ...dsComponents.MuiInputBase,
      styleOverrides: {
        ...dsComponents.MuiInputBase?.styleOverrides,
        root: props => mergeRootStyleOverrides(commonInputRoot, dsInputRoot, props)
      }
    },
    MuiButton: {
      ...dsComponents.MuiButton,
      styleOverrides: {
        ...dsComponents.MuiButton?.styleOverrides,
        root: props => mergeRootStyleOverrides(commonButtonRoot, dsButtonRoot, props)
      }
    }
  };
}
